export default "__VITE_ASSET__KEw4Tccz__"